module.exports = "/packs/images/homepage/whatson/stand_up_to_cancer_mobile~f693cbfb0ef8614ba4f7138c24197c82.jpg";